import React, { useEffect, ReactNode, useState } from "react";

interface TooltipProps {
  content: string | ReactNode; 
  position?: "top" | "bottom" | "left" | "right"; 
  className?: string; 
  children: ReactNode; 
  delay?: number;
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  position = "top",
  className = "",
  children,
  delay=1000
}) => {
    const [visible, setVisible] = useState(false);

    const showTooltip = () => {
        setVisible(true);
    };

    const hideTooltip = () => {
        setVisible(false);
    };

  useEffect(() => {
    if (visible) {
        const timer = setTimeout(() => {
            setVisible(false);
        }, delay);

        // Clear timer if the component unmounts or the visibility changes
        return () => clearTimeout(timer);
    }
}, [visible, delay]);


  return (
    <div className="relative inline-block">
      {/* Children element */}
      <div
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onFocus={showTooltip}
        onBlur={hideTooltip}
        className="inline-block"
        tabIndex={0} // Makes it keyboard accessible
      >
        {children}
      </div>

      {/* Tooltip */}
      {visible && (
        <div
        style={{ backgroundColor: "rgba(117, 72, 76, 0.95)" }}
          className={`absolute z-50 px-2.5 py-1.5 text-sm text-white rounded-lg shadow-elevation ring-1 ring-white/10 backdrop-blur-sm whitespace-nowrap animate-fade-in ${className} ${getTooltipPosition(
            position
          )}`}
        >
          {content}
        </div>
      )}
    </div>
  );
};

// Helper function to determine tooltip position
const getTooltipPosition = (position: string) => {
  // Mobile base (always bottom)
  const mobileClasses = "top-full left-1/2 transform -translate-x-1/2 mt-2";

  // Desktop overrides (using md: prefix)
  switch (position) {
    case "top":
      return `${mobileClasses} md:top-auto md:bottom-full md:mb-2 md:mt-0`;
    case "bottom":
      return mobileClasses; // Already matches base
    case "left":
      return `${mobileClasses} md:left-auto md:right-full md:top-1/2 md:-translate-x-0 md:-translate-y-1/2 md:mr-2 md:mt-0`;
    case "right":
      return `${mobileClasses} md:left-full md:top-1/2 md:-translate-x-0 md:-translate-y-1/2 md:ml-2 md:mt-0`;
    default:
      return mobileClasses;
  }
};

export default Tooltip;